export const ADD_BACKURL = 'ADD_BACKURL'
export const ADD_CLEARURL = 'ADD_CLEARURL'

export default {
  state: {
    backurl: localStorage.getItem('backurl') || ''
  },
  getters: {
    backurl: state => {
      return state || {}
    }
  },
  mutations: {
    [ADD_BACKURL](state, backurl) {
      localStorage.setItem('backurl', backurl)
      state.backurl = backurl
    },
    [ADD_CLEARURL]() {
      localStorage.removeItem('backurl')
    }
  }
}
